var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOilType(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 29.86 36.14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#1a1a1a;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Camada_2",
    "data-name": "Camada 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Camada_1-2",
    "data-name": "Camada 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M29.15,5.16a4.16,4.16,0,0,0-3.86-1.84q-6.87,0-13.74,0c-1.46,0-1.55-.11-1.6-1.54A2.37,2.37,0,0,0,9.48,0H4.27A2.1,2.1,0,0,0,3.8,1.54c-.07,1.71-.07,1.71-1.72,1.78S0,3.74,0,5.37Q0,19.94,0,34.51c0,1.46.22,1.63,1.64,1.63H28.08c1.6,0,1.76-.13,1.77-1.73q0-13.33,0-26.66A4.66,4.66,0,0,0,29.15,5.16ZM17.06,30a3.62,3.62,0,0,1-4.2,0,3.48,3.48,0,0,1-1.2-4.2A30.82,30.82,0,0,1,15,19.92a28.75,28.75,0,0,1,3.3,5.91A3.4,3.4,0,0,1,17.06,30ZM24.93,13.4c-2.73-.72-5.48-1.38-8.23-2.08-1.77-.46-1.77-.48-1.77-2.34a7.51,7.51,0,0,0,0-1c-.06-.58.18-.73.74-.72,1.5,0,3,0,4.49,0s2.92,0,4.37,0c.93,0,1.29.41,1.28,1.28,0,1.37,0,2.75,0,4.13C25.83,13.45,25.62,13.58,24.93,13.4Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOilType);
export default __webpack_public_path__ + "static/media/oil-type.381a1182bb56beb098ddf1de0aa84860.svg";
export { ForwardRef as ReactComponent };